import React, { useEffect, useState } from 'react';
import { getUserCases, getAppUser, getCookie } from '../../functions/utils';
import { handleBestandImport, resetBestandStatus } from '../../functions/bestand';
import '../../css/ImportComponent.css';
import ImportHeaderComponent from '../page/ImportHeaderComponent';
import DropdownComponent from '../utilities/DropdownComponent';
import LoaderComponent from '../utilities/LoaderComponent';
import FileDropComponent from '../utilities/FileDropComponent';
import BestandLogo from '../../images/BestandLogo.png';
import { useTranslations } from '../utilities/TranslationContext';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faChevronDown, faArrowLeft, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(faChevronDown, faXmark, faArrowLeft, faCircleCheck, faCircleXmark);

const BestandComponent = () => {
  const { getTranslation } = useTranslations();
  const [userCases, setUserCases] = useState([]);
  const [selectedCase, setSelectedCase] = useState(false);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);

  useEffect(() => { init(); }, []);

  async function init() {
    const appUser = await getAppUser();
    if (!appUser) return setTimeout(init, 300);
    const cases = await getUserCases();
    if (cases) setUserCases(cases);
  }

  function handleSelect(option) {
    if (option.type === 'case') setSelectedCase(option.value);
  }

  async function runImport() {
    setIsLoading(true);
    setResults([]);
    await resetBestandStatus();

    const newResults = [];
    for (const file of files) {
      let xmlContent;
      try {
        xmlContent = await file.text();
      } catch {
        newResults.push({ file: file.name, success: false, error: 'Kan bestand niet lezen' });
        continue;
      }
      try {
        const result = await handleBestandImport({
          entiteit: `${selectedCase}_1`,
          year: String(new Date().getFullYear()),
          jrnid: '',
          accid: '',
          fileName: file.name,
          xmlContent,
        });
        newResults.push({ file: file.name, success: true, ...result });
      } catch (e) {
        newResults.push({ file: file.name, success: false, error: e.message });
      }
    }

    setResults(newResults);
    setIsLoading(false);
  }

  async function runTest() {
    
    const appUser = await getAppUser();
    console.log(appUser);
    var response = await fetch('https://api2.factview.nl/api/3115/createImpBankTable', {
      method: 'POST',
      headers: {
        Authorization: 'Bearer '+appUser.access_token,
        // 'Content-Type': 'application/json',
      },
    });
    var responseData = await response.json();
    console.log(responseData);
  }

  const canImport = selectedCase && files.length > 0 && !isLoading;

  return (
    <div className="import-container">
      <ImportHeaderComponent
        title="Bestand"
        logo={BestandLogo}
        subtitle={getTranslation('import_BestandSubtitle')}
      />
      <div className="import-component-container">
        <div className="import-component-content">
          <div className="import-content">
            <LoaderComponent isLoading={isLoading} paddingTop="20px" />

            {!isLoading && (
              <>
                <div className="import-create-basic">
                  <div className="case-content">
                    <p>{getTranslation('import_FVCase')}*</p>
                    <DropdownComponent
                      options={userCases.map(c => ({ label: c.name, value: c.id, type: 'case' }))}
                      defaultValue={{ label: getTranslation('import_SelectCase'), value: null, type: null }}
                      onSelect={handleSelect}
                      className="case"
                    />
                  </div>
                </div>

                <FileDropComponent onFilesAccepted={setFiles} />

                <div className="import-menubar">
                  <button
                    className="import-btn submit-btn hover"
                    disabled={!canImport}
                    onClick={runImport}
                  >
                    Importeren
                  </button>
                  <button
                    className="import-btn submit-btn hover"
                    onClick={runTest}
                  >
                    Test
                  </button>
                </div>

                {results.length > 0 && (
                  <ul className="import-results-list">
                    {results.map((r, i) => (
                      <li key={i} className={`import-result-item ${r.success ? 'success' : 'error'}`}>
                        <FontAwesomeIcon icon={r.success ? faCircleCheck : faCircleXmark} />
                        <span className="import-result-filename">{r.file}</span>
                        {r.success
                          ? <span>{r.transactionCount} transacties · {r.fileType}</span>
                          : <span>{r.error}</span>
                        }
                      </li>
                    ))}
                  </ul>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestandComponent;
